import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
import HoverBullet from "./../hoverbullet"

const HoverBullets = ({ content, sectionOptions }) => {
  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  return (
    <section className={`${sectionClasses}`}>
      <div className="container">
        {content.title ? (
          <div className="flex justify-center pb-2">
            <div className="lrg:px-6 tab:w-9/12 text-center">
              <p>{content.title}</p>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={`w-full flex ${content.alignment}`}>
          <div
            className={`lg:w-1/2 lrg:px-6${
              content.alignment == "justify-center" ? " text-center" : ""
            }`}
          >
            {content.bullets
              ? content.bullets.map((bullet, index) => {
                  return <HoverBullet bullet={bullet} key={index} num={index + 1} />
                })
              : ""}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HoverBullets
